export const COVERAGE_MAP_PROD_URL = 'https://network-map.my.telia.lt/';
export const COVERAGE_MAP_STG_URL = 'https://network-map-stg.test-my.telia.lt/';
export const COVERAGE_MAP_DEV_URL = 'https://network-map-dev.test-my.telia.lt/';
